function isUndefined (val) {
    return val === undefined
}

function isNull (val) {
    return val === null
}

function isString(val) {
    return typeof val === 'string'
}

function isEmpty (val) {
    if (isString(val)) return !val.trim()
    return isNull(val) || isUndefined(val)
}

export default {
    props: {
        showDetail: {
            type: Boolean,
            default: false
        },
        api: {
            type: String,
            default: ''
        },
        data: {
            type: Array
        },
        dictType: { // 字典类型
            type: [String, Number]
        },
        params: {
            type: Object,
            default () {
                return {}
            }
        },
        value: {},
        multiple: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        clearable: {
            type: Boolean,
            default: true
        },
        collapseTags: {
            type: Boolean,
            default: true
        },
        multipleLimit: {
            type: Number,
            default: 0
        },
        filterable: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: String,
            default: '请选择'
        },
        noMatchText: {
            type: String,
            default: '无匹配数据'
        },
        noDataText: {
            type: String,
            default: '无数据'
        }
    },
    data () {
        return {
            dataSource: [],
            currentValue: ''
        }
    },
    watch: {
        value: {
            immdeiate: true,
            deep: true,
            handler (val) {
                this.currentValue = val
            }
        },
        currentValue (val) {
            this.$emit('input', val)
        },
        data: {
            deep: true,
            handler (val) {
                this.dataSource = val
            }
        },
        dictType: {
            handler () {
                this.select()
            }
        },
        api: {
            handler () {
                this.select()
            }
        },
        params: {
            handler () {
                this.select()
            }
        },
    },
    computed: {
        label () {
            if (!this.dataSource || this.dataSource.length === 0) return
            let index = this.dataSource.findIndex(it => String(it.id) === String(this.currentValue))
            if (index !== -1) return this.dataSource[index].label
        }
    },
    methods: {
        select () {
            if (this.data) this.dataSource = this.data
            else {
                if (!isEmpty(this.dictType)) {
                   this.getDict(this.dictType)
                } else {
                    this.$api(this.api, this.params).then(res => {
                        this.dataSource = res
                    }).catch(err => {
                        if (process.env.NODE_ENV === 'development') console.error(err)
                        this.$tips(err, 'error')
                    })
                }
            }
        },
        getDict (type) {
            if (!type) return
            this.$api(this.$FRAMEWORK.dictApi, {
                dictType: type
            }).then(res => {
                this.dataSource = res
            }).catch(err => {
                if (process.env.NODE_ENV === 'development') console.error(err)
                this.$tips(err, 'error')
            })
        },
        onVisibleChange (e) {
            this.$emit('visible-change', e)
        },
        onRemovetag (e) {
            this.$emit('remove-tag', e)
        },
        onBlur (e) {
            this.$emit('blur', e)
        },
        onFocus (e) {
            this.$emit('focus', e)
        },
        onClear () {
            this.$emit('clear')
        }
    },
    created() {
        this.select()
        this.currentValue = this.value
    }
}


// WEBPACK FOOTER //
// ./src/components/framework/widgets/select.js